import { gql } from "@apollo/client";

const RUN_NODE_FIELDS = `
  id
  status
  context
  subjectType
  subjectId
  project {
    id
  }
  process {
    id
  }
  currentNode {
    id
    name
    order
    progress
    nodeType
    formDefinition
    config
    possibleStatuses {
      id
      kind
      event
      nextStatus
      order
    }
    screens {
      id
      currentPublishedVersion {
        id
        versionNumber
        status
        htmlContent
        styleContent
        bindingManifest {
          id
          slots
        }
        translationTable {
          id
          entries
        }
        states {
          id
          name
          order
          htmlContent
          conditions
          bindingManifest {
            id
            slots
          }
        }
      }
    }
  }
  children {
    id
    status
    subjectType
    subjectId
    createdDate
    updatedDate
    currentNode {
      id
      name
      order
    }
  }
  steps {
    id
    nodeType
    status
    attempt
    output
    error
    startedAt
    finishedAt
    node {
      id
      name
    }
  }
  createdDate
  updatedDate
`;

export const START_PROJECT_RUN = gql`
  mutation StartRun(
    $project: ProjectDataInput!
    $process: ProcessDataInput!
  ) {
    startRun(project: $project, process: $process) {
      ${RUN_NODE_FIELDS}
    }
  }
`;

export const ADVANCE_PROJECT_RUN = gql`
  mutation AdvanceRun(
    $run: RunNodeWhereInput!
    $trigger: JSONObject
  ) {
    advanceRun(run: $run, trigger: $trigger) {
      ${RUN_NODE_FIELDS}
    }
  }
`;

export const RESUME_PROJECT_RUN = gql`
  mutation ResumeRun($resumeToken: String!, $payload: JSONObject) {
    resumeRun(resumeToken: $resumeToken, payload: $payload) {
      ${RUN_NODE_FIELDS}
    }
  }
`;

export const SIGNAL_PROJECT_RUN = gql`
  mutation SignalRun(
    $run: RunNodeWhereInput!
    $event: String!
    $trigger: JSONObject
  ) {
    signalRun(run: $run, event: $event, trigger: $trigger) {
      ${RUN_NODE_FIELDS}
    }
  }
`;

const projectRuns = {
  START_PROJECT_RUN,
  ADVANCE_PROJECT_RUN,
  RESUME_PROJECT_RUN,
  SIGNAL_PROJECT_RUN,
};

export default projectRuns;
